import React from 'react';
import { Body1, Body2 } from '@seekube-tech/ui-kit';
import Tags from '@/scenes/Events/scenes/components/JobdatingsYours/components/Tags';
import { CompaniesToDiscover } from '@/components/Card/components';
import colors from '@seekube-tech/ui-kit/dist/colors';

export const Infos = ({ event, authUser }) => (
  <div className="flex flex-col h-full">
    <div>
      <Body1 className="mb-8" color={colors.neutral['300']}>
        <Tags
          tagsList={['jobdatingDate', 'countOffers']}
          event={event}
          locale={authUser.locale}
        />
      </Body1>
    </div>
    <div className="grow">
      <Body2 color={colors.neutral['400']}>
        {event.calendarB2CDescription?.[authUser?.locale]}
      </Body2>
    </div>
    <div>
      <CompaniesToDiscover event={event} context="onboarding"/>
    </div>
  </div>
)
